import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';
import { PublicReviewDisplayItem, ReviewDisplayItem } from '@sb/library/data-models';

@Component({
    selector: 'lib-review-card',
    templateUrl: './review-card.component.html',
    styleUrls: ['./review-card.component.scss']
})
export class ReviewCardComponent extends BaseViewComponent {
    @Input({ required: true }) displayItem!: ReviewDisplayItem | PublicReviewDisplayItem;

    DisplayFirstNameAndLastInitial(): string {
        const firstName = ('Parent' in this.displayItem) ? this.displayItem.Parent?.FirstName : this.displayItem.ParentFirstName;
        const lastName = ('Parent' in this.displayItem) ? this.displayItem.Parent?.LastName : this.displayItem.ParentLastName;

        const lastInitial = lastName?.charAt(0)?.toUpperCase() ?? '';
        return lastInitial ? `${firstName} ${lastInitial}.` : firstName!;
    }
}
